<h1 mat-dialog-title>Upload Report</h1>
<mat-dialog-content class="mat-typography" style="white-space: pre-line;">
  {{data.text}}
</mat-dialog-content>
<mat-dialog-actions allign="end">
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
